<template>
  <div>
    <div class="document">
      <!-- <img src="../../../assets/img/logo/NAN_logomark_RGB_Evergreen.png" alt="" class="center" style="width: 110px; padding-bottom: 10px;" id="ignorePDF"> -->
      <img :src="require(`../../../assets/img/logo/${$store.getters.logo}`)" width="" :height="$store.getters.logoHeight" :alt="$store.getters.agencyHumanName" id="ignorePDF" class="center">
      <h3 style="text-align: center;" class="mt-3">{{ document.title }}</h3>
      <!-- {{ document }} -->
      <hr>

      <!-- <div class="mb-4" v-if="document.edit_access == 'All' || (document.edit_access == 'Admin' && $store.getters.isAgent === true) || (document.edit_access == 'User' && document.signing_user == user.id)"> -->
      <!-- <div class="mb-2" v-if="$store.getters.isAgent === true || (document.edit_access != 'Admin' && document.signing_user == user.id)"> -->
      <div class="mb-2" v-if="$store.getters.isAgent === true">
        <h3 style="margin-bottom: -10px;">Admin Only</h3>
        <div v-for="(field, index) in document.fields_labels" :key="'Field'+index" class="field-of-fields">
          <label>{{ field }}<span v-if="document.fields_required[index] === true">*</span></label>
          <textarea class="form-control" rows="3" v-model="fields[index]"></textarea>
        </div>
        <button class="mylisting-button dark-button mt-3 mb-3" @click="save()">Update</button>
        <hr>
        <hr>
      </div>

      <div v-if="document.status == 'Signed'">
        <pre v-html="documentBody"></pre>
      </div>
      <div v-else>
        <div v-if="(document.status == 'Unsigned' || document.status == 'Saved') && ($store.getters.isAgent === true || (document.edit_access != 'Admin' && document.signing_user == user.id))">
          <!-- <pre v-html="documentBody"></pre> -->
          <div v-if="fields.length">
            <div v-for="(field, index) in document.fields_labels" :key="'Field'+index" class="field-of-fields">
              <!-- {{ document.fields_required }} -->
              <!-- {{ document }} -->
              <!-- <pre v-html="documentBody[index]" style="margin-bottom: -10px;"></pre> -->
              <pre v-html="documentBody[index]" style=""></pre>
              <!-- <label style="margin-top: 0;">{{ field }}<span v-if="document.fields_required[index] === true">*</span></label> -->
              <textarea class="form-control" rows="1" v-model="fields[index]"></textarea>
              <!-- Need to display the last segment of text -->
              <pre v-if="index == (fields.length - 1)" v-html="documentBody[index+1]"></pre>
              <!-- <pre v-html="documentBody[document.fields_labels.length]"></pre> -->
            </div>
          </div>
          <div v-else>
            <pre v-html="documentBody"></pre>
          </div>
        </div>
        <div v-else>
          <pre v-html="documentBody"></pre>
        </div>
      </div>

      <div class="mb-5" v-if="$store.getters.isAgent === true">
        <button class="mylisting-button dark-button mt-3" @click="save()">Update</button>
      </div>

      <!-- <div v-for="(field, index) in document.fields_labels" :key="'Field'+index" class="field-of-fields">
        <label for="">{{ field }}<span v-if="document.fields_required[index] === true">*</span></label>
        <textarea class="form-control" rows="3" v-model="fields[index]"></textarea>
      </div> -->

      <!-- {{ template }} -->
      <!-- <pre>{{ template.body }}</pre> -->
      <!-- <pre v-html="template.body"></pre> -->
      <!-- <pre v-html="document.body"></pre> -->
      <!-- <pre v-html="documentBody"></pre> -->

      <!-- <div v-for="(signer_label, index) in template.signer_labels" :key="'Signer'+index"> -->
      <div v-for="(signer_label, index) in document.signer_labels" :key="'Signer'+index">
        <p style="font-weight: 600; margin-bottom: 0;">{{ signer_label }}</p>
        <p v-if="document.status == 'Unsigned'">{{ new Date().toDateString() }}</p>
        <p v-if="document.status == 'Signed'">{{ new Date(document.signing_date).toDateString() }}</p>
        <h2 v-if="signatures[index]" style="font-family: 'Arizonia'; text-transform: none;">{{ signatures[index] }}</h2>
        <h4 v-if="!signatures[index]">___________</h4>
        <p v-if="document.status == 'Signed'">{{ document.signers[index] }}</p>

        <div v-if="document.status == 'Unsigned'">
          <input type="text" class="form-control" v-model="signatures[index]" style="max-width: 700px;">
          <label class="mt-1">Please type your name to sign (you agree that this constitutes the equivalent of signing a physical document)</label>
          <!-- <div>
            <button v-if="!signatures[index]" class="mylisting-button disabled-button mt-3" style="cursor: not-allowed; color: gray;" @click.prevent="">Sign</button>
            <button v-if="signatures[index]" class="mylisting-button dark-button mt-3" @click="sign()">Sign</button>
          </div> -->
        </div>
      </div>

      <div v-if="document.signer_labels.length">
        <button v-if="allSigned" class="mylisting-button dark-button mt-3" @click="sign()">Sign</button>
      </div>

      <div v-if="!document.signer_labels.length">
        <button class="mylisting-button dark-button mt-3" @click="save()">Save</button>
      </div>

      <!-- <div v-if="template.organization_signer"> -->
      <div v-if="template.organization_signer">
        <p style="font-weight: 600; margin-top: 25px; margin-bottom: 0;">{{ $store.getters.agencyHumanName }}</p>
        <p v-if="document.status == 'Unsigned'">{{ new Date().toDateString() }}</p>
        <p v-if="document.status == 'Signed'">{{ new Date(document.signing_date).toDateString() }}</p>
        <!-- <h4 v-if="template.organization_signer" style="font-family: 'Arizonia'">{{ template.organization_signer }}</h4> -->
        <!-- <p>Per: {{ template.organization_signer }}</p> -->
        <h2 v-if="document.organization_signer" style="font-family: 'Arizonia'; text-transform: none;">{{ document.organization_signer }}</h2>
        <p>Per: {{ document.organization_signer }}</p>
      </div>

      <!-- {{ document }} -->
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {

  // title: template.name,
  // template: template.id,
  // signing_user: this.user.id,
  // status: 'Unsigned',
  // body: template.body,
  // fields_labels: template.fields,
  // fields_required: template.fields_required,
  // edit_access: template.edit_access,
  // organization_signer: template.organization_signer,
  // signer_labels: template.signer_labels,
  // agency_owner: this.$store.getters.agencyName,
  // agency: this.$store.getters.agencyID,

  props: ['user', 'document'],
  data() {
    return {
      template: {},
      signatures: [],
      signature: '',
      fields: [],
    }
  },
  created() {
    this.getTemplate()

    if (this.document.fields.length) {
      this.fields = this.document.fields
    }
    else { // If the document is not already filled, want to prepopulate the fields array with blanks for use with v-model
      for (var label in this.document.fields_labels) {
        this.fields.push('')
      }
    }

    // this.document.body.replace('[[firstname]]', this.user.first_name)
    // this.document.body.replace('[[lastname]]', this.user.last_name)
  },
  computed: {
    // documentBody() {
    //   let documentBody = this.document.body
    //   documentBody = documentBody.replace('[[firstname]]', this.user.first_name)
    //   documentBody = documentBody.replace('[[lastname]]', this.user.last_name)
    //   // documentBody.replace('NOTICE', 'blah')

    //   return documentBody
    // },

    documentBody() {
      this.document.body = this.document.body.replace('[[firstname]]', this.user.first_name)
      this.document.body = this.document.body.replace('[[lastname]]', this.user.last_name)

      let documentBody = null
      if (this.fields.length) {
        if (this.document.status == 'Signed' || (this.document.edit_access == 'Admin' && this.document.signing_user == this.$store.getters.userID)) {
          documentBody = this.document.body
          // console.log(documentBody)
        }
        else if (this.document.status == 'Unsigned' || this.document.status == 'Saved') {
          documentBody = []
          documentBody[0] = this.document.body
          console.log(this.document.body)
        }
        let num = 0
        let thing = `[[field${num}]]`
        // documentBody = documentBody.replace(`[[field1]]`, this.fields[1])
        for (var field in this.fields) {
          // if (this.document.status == 'Signed') { // If the document is filled/signed, we want to replace all the [field] references with whatever was entered
          if (this.document.status == 'Signed' || (this.document.edit_access == 'Admin' && this.document.signing_user == this.$store.getters.userID)) { // If the document is filled/signed, we want to replace all the [field] references with whatever was entered
            console.log(`[[field${field}]]`)
            // documentBody = documentBody.replace(`[[field${field}]]`, this.fields[field])
            // https://stackoverflow.com/questions/13340131/javascript-replaceall-not-working
            documentBody = documentBody.split(`[[field${field}]]`).join(this.fields[field])
          }
          else if (this.document.status == 'Unsigned' || this.document.status == 'Saved') { // If the document has not been signed or is not one that needs to be signed, we want to split it into pieces at each of the [field] references, so we can display inline text boxes to fill it
            // documentBody[field] = documentBody[field].split(`[[field${field}]]`)
            let remainingDocument = documentBody.pop() // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/pop
            documentBody = documentBody.concat(remainingDocument.split(`[[field${field}]]`)) // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/concat
          }
        }
        // documentBody = documentBody.replace(thing, 'blahhblah')
      }
      else {
        documentBody = this.document.body
      }

      return documentBody
    },
    allSigned() {
      if (this.signatures.length) {
        for (var signature in this.signatures) {
          if (this.signatures[signature] == '') {
            return false
          }
        }
        return true
      }
      else {
        return false
      }
    },
  },
  methods: {
    getTemplate() {
      axios.get(`/api/documenttemplates/?id=${this.document.template}`)
        .then(res => {
          this.template = res.data[0]

          if (this.document.status == 'Unsigned') {
            for (var signer_label in this.template.signer_labels) {
              this.signatures.push('')
            }
          }
          else if (this.document.status == 'Signed') {
            this.signatures = this.document.signers
          }
        })
        .catch(error => console.log(error))
    },
    sign() {
      axios.patch(`/api/documents/${this.document.id}/`, {
        signers: this.signatures,
        signing_date: this.todayDatetimeDjangoFormat,
        fields: this.fields,
        status: 'Signed',
      })
        .then(res => {
          console.log(res)
          this.$emit('documentSigned')
        })
        .catch(error => {
          console.log(error)
        })
    },
    save() {
      axios.patch(`/api/documents/${this.document.id}/`, {
        fields: this.fields,
        status: 'Signed',
      })
        .then(res => {
          console.log(res)
          this.$emit('documentSigned')
        })
        .catch(error => {
          console.log(error)
        })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/candidates/profile/Document.vue